"use client";

import { useRouter, usePathname } from "next/navigation";
import { useMemo, useEffect } from "react";

import { useStyles } from "./styles";
import { useAppSelector, useAppDispatch } from "@/redux/store";
import { getQuotas } from "@/redux/actions";
import { useLocalStorage } from "@/hooks/useStorage";

const DailyGensSummary = () => {
  const { classes } = useStyles();
  const dispatch = useAppDispatch();
  const router = useRouter();
  const pathname = usePathname();
  const user = useAppSelector((state) => state.user.user);
  const isSubscribed = Boolean(user && user.subscriptionType !== "free");
  const quotas = useAppSelector((state) => state.user.quotas);
  const [_, setRedirectPath] = useLocalStorage("redirectPath", "/");

  const quota = useMemo(() => {
    return quotas.find((quota) => quota.resourceName === "gen") || null;
  }, [quotas]);

  const handleGetMoreClick = () => {
    setRedirectPath(pathname || "/");
    router.push("/subscribe");
  };

  useEffect(() => {
    if (!isSubscribed) {
      dispatch(getQuotas());
    }
  }, [isSubscribed, dispatch]);

  const hasUsedQuota = quota && quota.currentQuota < quota.baseQuota;

  if (!quota || isSubscribed || !hasUsedQuota) return null;

  return (
    <div className={classes.container}>
      <div className={classes.creditsInfo}>
        <span className={classes.creditsLabel}>Daily Gens</span>
        <span className={classes.creditsCount}>
          {quota.currentQuota}/{quota.baseQuota}
        </span>
      </div>
      <button className={classes.getMoreButton} onClick={handleGetMoreClick}>
        Get More
        <span className={classes.plusIcon}>+</span>
      </button>
    </div>
  );
};

export default DailyGensSummary;
